import { useId, useState } from "react";
import { getVehicleDescription } from "../data/vehicleDescriptions";

const VehicleDetailsDropdown = ({ car }) => {
  const [isOpen, setIsOpen] = useState(false);
  const reactId = useId();
  const panelId = `car-details-${reactId.replace(/:/g, "")}`;

  return (
    <>
      <div className="Heading">
        <h4 className="Head_3">{car.name}</h4>
        <button
          type="button"
          className="car-details-toggle"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={() => setIsOpen((current) => !current)}
        >
          <span>Details</span>
          <span className="car-details-chevron" aria-hidden="true" />
        </button>
      </div>

      <div
        id={panelId}
        className={`car-details-panel ${isOpen ? "is-open" : ""}`}
      >
        <div className="car-details-inner">
          <span className="car-details-label">Vehicle overview</span>
          <p>{getVehicleDescription(car)}</p>
          <div className="car-detail-facts">
            <span>{car.isAutomatic ? "Automatic" : "Manual"}</span>
            <span>{car.seats} seats</span>
            <span>{car.bags} bags</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleDetailsDropdown;
